package devxertech.com.pages.commons

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import devxertech.com.section.DesktopNavigationAnchor
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.section.SideBar
import devxertech.com.section.TopBar
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import kotlinx.coroutines.delay
import devxertech.com.utils.imageLoading
import org.w3c.dom.HTMLImageElement
import org.w3c.dom.events.EventListener

@Composable
fun CommonHeader(image: String,
                 breakpoint: Breakpoint,
                 headingText : String,
                 descriptionText : String,
                 startProject: Boolean = true,
                 careerHeight: Boolean = false,
                 careerHeaderText: Boolean = false,
                 careerFontSize: Boolean = false,
                 showExtraText: Boolean = true,
                 commonPortfolioChanges: Boolean = false,
                 chatbotHeightModification: Boolean = false, chatbotChanges: Boolean = false,
                 heightModification: Boolean = false, careerHeightModification: Boolean = false,
                 mainHeadingAsH1: Boolean = false,
                 loadingSkeleton: Boolean = false,
                 imageLoaded: Boolean = true,
                 fadeImage: Boolean = false,
                 preserveImageAspectRatio: Boolean = false,
                 imageAlt: String = "",
                 compactArticleHero: Boolean = false,
                 startProjectText: String = "Start A Project",
                 startProjectButtonWidth: Int = 170,
                 onImageLoad: (() -> Unit)? = null,
                 onImageError: (() -> Unit)? = null) {
    val sitePalette = ColorMode.current.toSitePalette()
    var isQuoteHovered by remember { mutableStateOf(false) }
    var isSideMenuOpen by remember { mutableStateOf(false) }
    var isButtonHovered by remember { mutableStateOf(false) }

    if (isSideMenuOpen || breakpoint < Breakpoint.XL) {
        SideBar(breakpoint = breakpoint, isOpen = isSideMenuOpen, onClose = { isSideMenuOpen = false }, showExtraText = true)
    }
    Box(modifier = Modifier.fillMaxWidth()
        .position(Position.Relative))
    {
        Column(modifier = Modifier.fillMaxWidth()
            .height(if (careerHeight || compactArticleHero) 630.px else if (breakpoint > Breakpoint.MD || chatbotHeightModification) 830.px else 730.px)
            .styleModifier {
                if (compactArticleHero && breakpoint <= Breakpoint.MD) property("height", "auto")
            }
            .backgroundImage(
                linearGradient(
                    LinearGradient.Direction.ToBottomLeft,
                    sitePalette.headerGradientOne.rgb,
                    sitePalette.headerGradientTwo.rgb)
            )
        ) {
            TopBar(breakpoint, onMenuClick = { isSideMenuOpen = true }, showExtraText, isServiceHeader = true, )
            Row(
                modifier = Modifier.fillMaxWidth()
                    .padding(leftRight = if (breakpoint <= Breakpoint.MD) 30.px else 122.px,
                        top = when {
                            careerHeight -> if (breakpoint <= Breakpoint.MD) 150.px else 0.px
                            compactArticleHero -> if (breakpoint <= Breakpoint.MD) 92.px else 0.px
                            else -> if (breakpoint < Breakpoint.MD) 50.px else 20.px
                        },
                        bottom = if (compactArticleHero && breakpoint <= Breakpoint.MD) 32.px else 0.px)
                    .then(if (compactArticleHero && breakpoint > Breakpoint.MD) Modifier.height(630.px) else Modifier)
                    .flexWrap(if (breakpoint < Breakpoint.MD) FlexWrap.Wrap else FlexWrap.Nowrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = if (breakpoint >= Breakpoint.MD) Arrangement.SpaceAround else Arrangement.Center
            ) {
                Column (
                    horizontalAlignment = if (breakpoint > Breakpoint.MD) Alignment.Start else Alignment.CenterHorizontally,){
                    if (loadingSkeleton) {
                        if (compactArticleHero) {
                            Column(
                                modifier = Modifier.width(if (breakpoint <= Breakpoint.MD) 300.px else 600.px)
                                    .styleModifier {
                                        // Reserve title and byline space while CMS content is loading.
                                        property("min-height", if (breakpoint <= Breakpoint.MD) "238px" else "240px")
                                    },
                                verticalArrangement = Arrangement.spacedBy(0.px),
                            ) {
                                repeat(3) { index ->
                                    Box(modifier = Modifier.fillMaxWidth().height(16.px)
                                        .margin(top = if (breakpoint <= Breakpoint.MD) 12.px else 22.px,
                                            bottom = if (breakpoint <= Breakpoint.MD) 12.px else 22.px)
                                        .styleModifier {
                                            property("width", if (index == 2) "72%" else "100%")
                                            property("background-color", "rgba(255,255,255,.26)")
                                            property("border-radius", "6px")
                                        })
                                }
                                Box(modifier = Modifier.width(if (breakpoint <= Breakpoint.MD) 210.px else 300.px)
                                    .height(14.px).margin(top = 10.px, bottom = 20.px)
                                    .styleModifier {
                                        property("background-color", "rgba(255,255,255,.2)")
                                        property("border-radius", "6px")
                                    })
                            }
                        } else {
                            Box(modifier = Modifier
                                .width(if (breakpoint < Breakpoint.MD) 300.px else 600.px)
                                .height(if (breakpoint < Breakpoint.MD) 72.px else 106.px)
                                .margin(top = if (breakpoint < Breakpoint.MD) 70.px else 70.px)
                                .styleModifier {
                                    property("background-color", "rgba(255,255,255,.26)")
                                    property("border-radius", "6px")
                                })
                            Box(modifier = Modifier
                                .width(if (breakpoint < Breakpoint.MD) 280.px else 530.px)
                                .height(if (breakpoint < Breakpoint.MD) 48.px else 54.px)
                                .margin(top = 10.px, bottom = 20.px)
                                .styleModifier {
                                    property("background-color", "rgba(255,255,255,.2)")
                                    property("border-radius", "6px")
                                })
                        }
                    } else FieldTitleTextNormalSimple(
                        text = headingText,
                        asH1 = mainHeadingAsH1,
                        width = if(window.screen.width in 400..1269)400.px else if(window.screen.width < 400 ) 300.px
                        else if(window.screen.width in 1270.. 1600) 600.px
                        else 750.px,
                        color = sitePalette.bodyBackgroundSecondary.rgb,
                        fontSize = when {
                            window.screen.width > 1600 -> 50.px
                            window.screen.width in 1270.. 1599 -> 48.px
//                            breakpoint > Breakpoint.LG -> 65.px
                            else -> 30.px
                        },
//                        fontSize = if (breakpoint > Breakpoint.LG) 65.px else if(window.screen.width in 1270.. 1450) 45.px else 32.px,
                        textAlign = if(breakpoint >= Breakpoint.MD) TextAlign.Start else TextAlign.Center,
                        fontWeight = 600,
                        marginTop = when {
                            compactArticleHero -> 0.px
                            window.screen.width > 1640 -> if (careerFontSize) 70.px else 90.px
                            window.screen.width in 800..1200 -> if (careerFontSize) (-30).px else 0.px
                            window.screen.width < 800 -> if (careerFontSize) 0.px else 70.px
                            else -> 70.px
                        },
                        paddingTop = if (chatbotChanges && breakpoint <= Breakpoint.MD) 50.px else 0.px,
                        lineHeight = if (breakpoint <= Breakpoint.LG) 40.px else
                            if (window.screen.width > 1600) 55.px else 60.px,
                        whiteSpace = WhiteSpace.PreWrap
                    )
                    if (!loadingSkeleton) FieldTitleTextNormalSimple(
                        text = descriptionText,
//                        width = if(window.screen.width in 400..1269) 400.px else if(window.screen.width < 400 ) 300.px else if(breakpoint < Breakpoint.ZERO) 200.px else 750.px,
                        width = if(window.screen.width in 400..1269)400.px else if(window.screen.width < 400 ) 300.px
                        else if(window.screen.width in 1270.. 1600) 530.px
                        else 750.px,
                        color = sitePalette.bodyBackgroundSecondary.rgb,
                        fontSize = when {
                            window.screen.width > 1600 -> 22.px
                            window.screen.width in 900..1269 -> if (careerFontSize) 17.px else 20.px
                            breakpoint >= Breakpoint.MD -> 20.px
                            else -> 16.px
                        },
                        textAlign =  if(breakpoint >= Breakpoint.MD) TextAlign.Start else TextAlign.Center,
                        fontWeight = 500,
                        marginTop = if (careerHeaderText) 5.px else 10.px,
                        marginBottom = 20.px,
                        whiteSpace = WhiteSpace.PreWrap
                    )
                    if  (breakpoint <= Breakpoint.MD){
                        HeaderImageSlot(
                            onImageLoad = onImageLoad,
                            onImageError = onImageError,
                            image = image,
                            loaded = imageLoaded,
                            fadeIn = fadeImage,
                            preserveAspectRatio = preserveImageAspectRatio,
                            imageAlt = imageAlt,
                            compactArticleHero = compactArticleHero,
                            modifier = Modifier
                                .width(300.px)
                                .then(if (compactArticleHero) Modifier else Modifier.height(249.px))
                                .margin(top = if (careerHeight || compactArticleHero) 0.px else 20.px)
                        )
                    }
                    if (startProject) {

                        DesktopNavigationAnchor("/contact-us", Modifier
                                .width(startProjectButtonWidth.px)
                                .height(42.px)
                                .borderRadius(6.px)
                                .cursor(Cursor.Pointer)
                                .onMouseEnter { isButtonHovered = true }
                                .onMouseLeave { isButtonHovered = false }
                                .margin(top = if (breakpoint <= Breakpoint.MD) 30.px else 0.px)
                                .position(Position.Relative)
                                .display(DisplayStyle.Flex)
                                .justifyContent(JustifyContent.Center)
                                .backgroundColor(if (isButtonHovered) Colors.White else sitePalette.commonSecondaryButtonColor.rgb)
                                .styleModifier {
                                    property("background-color", "#254D79") // base color (blue)
                                    property("color", "white")
                                    property("align-items", "center")
                                }) {
                            // Overlay Box like ::before
                            Box(
                                modifier = Modifier
                                    .fillMaxSize()
                                    .position(Position.Absolute)
                                    .top(0.px)
                                    .left(0.px)
                                    .borderRadius(6.px)
                                    .backgroundColor(if (isButtonHovered) sitePalette.bodyBackgroundSecondary.rgb else sitePalette.commonSecondaryButtonColor.rgb)
                                    .zIndex(0)
                                    .styleModifier {
                                        property("will-change", "clip-path")
                                        property("transition", "clip-path 0.2s ease-in-out, opacity 0.1s ease-in-out")
                                        property("opacity", if (isButtonHovered) "1" else "0.999")
                                        property(
                                            "clip-path",
                                            if (isButtonHovered)
                                                "polygon(0% 100%, 0% 0%, 100% 0%, 100% 100%)"
                                            else
                                                "polygon(98% 98%, 99% 98%, 99% 99%, 98% 99%)"
                                        )
                                    }
                            )
                            Box(
                                modifier = Modifier
                                    .size(12.px)
                                    .position(Position.Absolute)
                                    .bottom(0.px)
                                    .right(0.px)
                                    .borderRadius(2.px)
                                    .backgroundColor(if (isButtonHovered) sitePalette.commonSecondaryButtonColor.rgb else sitePalette.bodyBackgroundSecondary.rgb)
                                    .transform {
                                        translateX(5.5.px)
                                        translateY(5.px)
                                    }
                                    .zIndex(10)
                                    .styleModifier {
                                        property("opacity", if (isButtonHovered) "0" else "1")
                                        property("transition", "opacity 0.0s ease")
                                    }
                            )


                            SpanText( text = startProjectText,
                                modifier = Modifier
                                    .fontFamily(Constants.FONT_FAMILY)
                                    .fontSize(17.px)
                                    .letterSpacing(0.3.px)
                                    .fontWeight(500)
                                    .color(if (isButtonHovered) sitePalette.commonSecondaryButtonColor.rgb else sitePalette.bodyBackgroundSecondary.rgb)
                                    .zIndex(1))
                        }
                    }

//                        CommonButton(text = "Start A Project", onClick = {ctx.router.navigateTo("/contact-us") })
//                        Box(
//                            modifier = Modifier
//                                .width(182.px)
//                                .height(41.px)
//                                .margin(top = if (breakpoint > Breakpoint.MD)10.px else 30.px)
////                                .backgroundImage(
////                                    linearGradient(
////                                            LinearGradient.Direction.ToRight,
////                                            sitePalette.commonSecondaryButtonColor.rgb,
////                                            sitePalette.topBarButton.rgb
////                                        )
////                                )
//                                .backgroundColor(sitePalette.commonSecondaryButtonColor.rgb)
////                                .onMouseEnter { isQuoteHovered = true }
////                                .onMouseLeave { isQuoteHovered = false }
//                                .cursor(Cursor.Pointer)
//                                .align(if (breakpoint <= Breakpoint.MD) Alignment.CenterHorizontally else Alignment.Start)
//                                .onClick { ctx.router.navigateTo("/contact-us") },
//                            contentAlignment = Alignment.Center
//                            ) {
//                                Row(
//                                    modifier = Modifier.fillMaxWidth(),
//                                    verticalAlignment = Alignment.CenterVertically,
//                                    horizontalArrangement = Arrangement.SpaceEvenly
//                                ) {
//                                    FieldTitleTextNormalSimple(
//                                        " Start A Project",
//                                        isClickable = true,
//                                        color = sitePalette.bodyBackground.rgb,
//                                        fontSize = 17.px
//                                    )
////                                    FaArrowRight(
////                                        modifier = Modifier.color(
////                                            color = sitePalette.bodyBackground.rgb
////                                        )
////                                    )
//                                }
//                            }

                    }

                    if  (breakpoint > Breakpoint.MD){
                    HeaderImageSlot(
                        onImageLoad = onImageLoad,
                        onImageError = onImageError,
                        image = image,
                        loaded = imageLoaded,
                        fadeIn = fadeImage,
                        preserveAspectRatio = preserveImageAspectRatio,
                        imageAlt = imageAlt,
                        compactArticleHero = compactArticleHero,
                        modifier = Modifier
                            .width(
                                when{
                                    window.screen.width > 1670 && commonPortfolioChanges-> 32.percent
                                    window.screen.width > 1610 -> 40.percent
                                    else -> 45.percent
                                }
//                                if (window.screen.width > 1675) 40.percent
//                                else 45.percent
                            )
                            .then(if (compactArticleHero) Modifier else Modifier.height(
                                when {
                                    window.screen.width > 1610 && careerHeightModification -> 485.px
                                    window.screen.width > 1600 && heightModification -> 575.px
                                    window.screen.width >= 1440 && heightModification -> 550.px
                                    breakpoint > Breakpoint.XL -> 450.px
                                    else -> 640.px
                                }
                            ))
                            .margin(
                                top = if (compactArticleHero) 0.px else when {
                                    window.screen.width > 1610 && careerHeightModification -> 110.px
                                    window.screen.width > 1600 && heightModification -> 85.px
                                    window.screen.width in 800..1200 -> 37.px
                                    else -> 70.px
                                },
                                left = if (window.screen.width in 800..1200) 0.px else (0).px
                            )
                    )
                }
            }
        }
    }
}

@Composable
private fun HeaderImageSlot(
    image: String,
    loaded: Boolean,
    fadeIn: Boolean,
    modifier: Modifier,
    preserveAspectRatio: Boolean = false,
    imageAlt: String = "",
    compactArticleHero: Boolean = false,
    onImageLoad: (() -> Unit)? = null,
    onImageError: (() -> Unit)? = null,
) {
    val imageAttributes = Modifier.imageLoading(
        image, highPriority = true,
        sizes = "(max-width: 767px) 300px, 45vw",
    ).attrsModifier {
        ref { element ->
            val imageElement = element as HTMLImageElement
            val loadListener = EventListener { onImageLoad?.invoke() }
            val errorListener = EventListener { onImageError?.invoke() }
            imageElement.addEventListener("load", loadListener)
            imageElement.addEventListener("error", errorListener)
            if (imageElement.complete && imageElement.naturalWidth > 0) onImageLoad?.invoke()
            onDispose {
                imageElement.removeEventListener("load", loadListener)
                imageElement.removeEventListener("error", errorListener)
            }
        }
    }
    var revealed by remember(image) { mutableStateOf(!fadeIn) }
    LaunchedEffect(loaded) {
        if (loaded && fadeIn) {
            revealed = false
            delay(16)
            revealed = true
        } else if (!loaded) revealed = false
    }
    if (compactArticleHero) {
        Box(modifier = modifier.styleModifier {
            property("height", "auto")
            property("aspect-ratio", "4 / 3")
            property("display", "grid")
            property("place-items", "center")
            property("overflow", "hidden")
            property("border-radius", "8px")
            property("background-color", if (loaded) "transparent" else "rgba(255,255,255,.18)")
        }) {
            if (loaded) {
                Image(
                    src = image,
                    modifier = Modifier.fillMaxSize().then(imageAttributes).attrsModifier {
                        attr("data-blog-hero", "")
                        if (imageAlt.isNotBlank()) attr("alt", imageAlt)
                    }.styleModifier {
                        property("width", "100%")
                        property("height", "100%")
                        property("object-fit", "contain")
                        property("opacity", if (!fadeIn || revealed) "1" else "0")
                        property("transition", if (fadeIn && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) "opacity 180ms ease-out" else "none")
                    }
                )
            }
        }
    } else if (loaded) {
        Image(
            src = image,
            modifier = modifier.then(imageAttributes).attrsModifier {
                if (imageAlt.isNotBlank()) attr("alt", imageAlt)
            }.styleModifier {
                if (preserveAspectRatio) {
                    property("height", "auto")
                    property("max-width", "100%")
                    property("object-fit", "contain")
                }
                property("opacity", if (!fadeIn || revealed) "1" else "0")
                property("transition", if (fadeIn && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) "opacity 180ms ease-out" else "none")
            }
        )
    } else {
        Box(modifier = modifier.styleModifier {
            property("background-color", "rgba(255,255,255,.18)")
            property("border-radius", "8px")
        })
    }
}


